import { isDevMode } from '@angular/core';
import { I18N_CONFIG } from '@indutrust/shared-model';
import { TranslocoHttpLoader } from './transloco-loader/transloco-loader.service';

export const translocoConfig = {
  config: {
    availableLangs: I18N_CONFIG.languages.map((language) => language.code),
    defaultLang: I18N_CONFIG.defaultLanguage.code,
    fallbackLang: I18N_CONFIG.defaultLanguage.code,
    failedRetries: 1,
    // Remove this option if your application doesn't support changing language in runtime.
    reRenderOnLangChange: true,
    prodMode: !isDevMode(),
    missingHandler: {
      allowEmpty: true,
      // It will use the first language set in the `fallbackLang` property
      useFallbackTranslation: true,
      logMissingKey: true,
    },
    flatten: {
      aot: !isDevMode(),
    },
  },
  loader: TranslocoHttpLoader,
};
